import React, { useRef } from "react";
import { Toast } from "primereact/toast";
import { CircleCheck, CircleX } from "lucide-react";

// This is the actual component that renders the toast
const ToastComponent = () => {
  const toast = useRef(null);

  ToastService.setToast(toast); // Set the reference to the toast here

  return <Toast ref={toast} position="bottom-left" />;
};

// This is the toast service class
class ToastService {
  static toast = null;

  static setToast(toastRef) {
    this.toast = toastRef;
  }

  static showToast(severity, summary, detail, life) {
    if (this.toast?.current) {
      this.toast.current.show({
        severity,
        summary,
        detail,
        life,
      });
    }
  }

  static showSuccessToast(summary) {
    if (this.toast?.current) {
      this.toast.current.show({
        severity: "success",
        summary,
        detail: null,
        life: 10000,
        content: () => {
          return (
            <div className="toast-content">
              <CircleCheck size={20} className="icon icon-success-toast" />
              <p className="p-toast-message-text">{summary}</p>
            </div>
          );
        },
      });
    }
  }

  static showErrorToast(summary) {
    if (this.toast?.current) {
      this.toast.current.show({
        severity: "error",
        summary,
        detail: null,
        life: 3000,
        content: () => {
          return (
            <div className="toast-content">
              <CircleX size={20} className="icon icon-danger-toast" />
              <p className="p-toast-message-text">{summary}</p>
            </div>
          );
        },
      });
    }
  }
}

export { ToastComponent, ToastService };
